"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1228],{

/***/ 50703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _metatrustlabs_ui_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90333);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83094);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(128);
/* harmony import */ var common_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14234);
/* harmony import */ var utils_debounce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22049);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70810);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var common_const__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29425);









var AIIntegrationSetting = function(param) {
    var client = param.client, name = param.name, data = param.data, onClose = param.onClose, visible = param.visible, origin = param.origin, deleteCallback = param.deleteCallback;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((data === null || data === void 0 ? void 0 : (ref = data.attributes) === null || ref === void 0 ? void 0 : ref.apiKey) || ""), apiKey = ref2[0], setApiKey = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), inputErrer = ref3[0], setInputErrer = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(Boolean(data === null || data === void 0 ? void 0 : (ref1 = data.attributes) === null || ref1 === void 0 ? void 0 : ref1.apiKey) === false || false), isEdit = ref4[0], setIsEdit = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref5[0], setIsLoading = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpenConfigure = ref6[0], setIsOpenConfigure = ref6[1];
    var handleDeleteIntegration = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        (0,api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_3__/* .apiList.integration["delete"] */ .X9.integration["delete"], {
            type: client
        }).then(function(res) {
            react_toastify__WEBPACK_IMPORTED_MODULE_4__/* .toast.success */ .Am.success("Removed successfully!");
            deleteCallback();
            onClose();
        }).catch(function(err) {
            react_toastify__WEBPACK_IMPORTED_MODULE_4__/* .toast.error */ .Am.error(err.message);
        });
    }, [
        client,
        onClose,
        deleteCallback
    ]);
    var checkApiKey = function() {
        var regex = /^sk-[a-zA-Z0-9]{48}$/;
        if (!apiKey || !regex.test(apiKey)) {
            return false;
        }
        return true;
    };
    var handleCreateOrUpdateAIIntegration = function() {
        var ref;
        if (!checkApiKey()) {
            setInputErrer("There is no Open AI API input");
            return;
        }
        setIsLoading(true);
        if (data === null || data === void 0 ? void 0 : (ref = data.attributes) === null || ref === void 0 ? void 0 : ref.apiKey) {
            (0,api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_3__/* .apiList.integration.update */ .X9.integration.update, {
                client: client,
                apiKey: apiKey
            }).then(function() {
                setIsLoading(false);
                react_toastify__WEBPACK_IMPORTED_MODULE_4__/* .toast.success */ .Am.success("Saved successfully!");
                deleteCallback();
                onClose();
            }).catch(function(err) {
                react_toastify__WEBPACK_IMPORTED_MODULE_4__/* .toast.error */ .Am.error("Failed to save, please try again later!");
                setIsLoading(false);
            });
        } else {
            (0,api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_3__/* .apiList.integration.create */ .X9.integration.create, {
                client: client,
                apiKey: apiKey
            }).then(function() {
                setIsLoading(false);
                react_toastify__WEBPACK_IMPORTED_MODULE_4__/* .toast.success */ .Am.success("Saved successfully!");
                deleteCallback();
                onClose();
            }).catch(function(err) {
                react_toastify__WEBPACK_IMPORTED_MODULE_4__/* .toast.error */ .Am.error("Failed to save, please try again later!");
                setIsLoading(false);
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_metatrustlabs_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Dialog */ .Vq, {
        onClose: function() {
            onClose();
        },
        cancelable: false,
        isOpen: visible,
        size: "sm",
        title: "".concat(name),
        className: "max-w-2xl",
        closeButton: origin === common_types__WEBPACK_IMPORTED_MODULE_5__/* .AIIntegrationOrigin.INTEGRATION */ .bi.INTEGRATION || isOpenConfigure ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_metatrustlabs_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
            size: "sm",
            onClick: function() {
                if (isOpenConfigure) {
                    setIsOpenConfigure(false);
                    return;
                }
                if (!isEdit) {
                    handleDeleteIntegration();
                } else {
                    onClose();
                }
            },
            intent: "primary",
            children: isEdit ? "Cancel" : "Remove"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
        confirmButton: origin === common_types__WEBPACK_IMPORTED_MODULE_5__/* .AIIntegrationOrigin.INTEGRATION */ .bi.INTEGRATION || isOpenConfigure ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_metatrustlabs_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
            size: "sm",
            isLoading: isLoading,
            intent: "highlight",
            onClick: function() {
                if (!isEdit) {
                    setIsEdit(true);
                    return;
                }
                handleCreateOrUpdateAIIntegration();
            },
            children: isEdit ? "Save" : "Edit"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "p-12",
            children: [
                origin === common_types__WEBPACK_IMPORTED_MODULE_5__/* .AIIntegrationOrigin.STARTSCAN */ .bi.STARTSCAN && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-800 text-2xl font-medium text-center",
                            children: "Go Premium for Advanced AI"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-gray-600 text-sm leading-6",
                            children: [
                                "The current organization is on a free subscription. To use any of our advanced AI-based features, you can upgrade to a",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-bold",
                                    children: "Premium"
                                }),
                                " plan, or manually configure an ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-bold",
                                    children: "OpenAI integration"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center mx-auto justify-center gap-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_metatrustlabs_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    intent: "secondary",
                                    onClick: function() {
                                        return setIsOpenConfigure(true);
                                    },
                                    children: "Continue with Free Plan"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_metatrustlabs_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    intent: "highlight",
                                    onClick: function() {
                                        router.push(common_const__WEBPACK_IMPORTED_MODULE_7__/* .ROUTE.subscription.select */ .ln.subscription.select);
                                    },
                                    children: "Upgrade to Premium"
                                })
                            ]
                        })
                    ]
                }),
                origin === common_types__WEBPACK_IMPORTED_MODULE_5__/* .AIIntegrationOrigin.STARTSCAN */ .bi.STARTSCAN && isOpenConfigure && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-between pt-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1 h-0 border boeder-gray-200 mr-5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-400 text-sm",
                            children: "Configure Open AI Integration"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1 h-0 border boeder-gray-200 ml-5"
                        })
                    ]
                }),
                (origin === common_types__WEBPACK_IMPORTED_MODULE_5__/* .AIIntegrationOrigin.INTEGRATION */ .bi.INTEGRATION || isOpenConfigure) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between pt-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-gray-600 text-sm font-medium",
                                    children: "OpenAI API Key"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "https://platform.openai.com/docs/guides/production-best-practices/api-keys",
                                    className: "text-orange-500 hover:text-orange-600 text-sm",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "How to obain an API Key?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_metatrustlabs_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .TextField */ .nv, {
                            defaultValue: apiKey,
                            disabled: !isEdit || isLoading,
                            placeholder: "sk-....",
                            onChange: (0,utils_debounce__WEBPACK_IMPORTED_MODULE_8__/* .debounce */ .D)(function(e) {
                                setApiKey(e.target.value);
                            }, 300),
                            className: "pt-4"
                        }),
                        inputErrer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs text-blue-500 pt-2",
                            children: inputErrer
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AIIntegrationSetting);


/***/ }),

/***/ 43987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ onboarding_OnboardingTour; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.13_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/ArrowDownIcon.js
var ArrowDownIcon = __webpack_require__(12585);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.13_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/ArrowUpIcon.js
var ArrowUpIcon = __webpack_require__(27105);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.13_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(51116);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.13_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/ArrowLeftIcon.js
var ArrowLeftIcon = __webpack_require__(2978);
// EXTERNAL MODULE: ./src/hooks/useOnboarding.ts
var useOnboarding = __webpack_require__(2455);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-joyride@2.5.3_react-dom@18.2.0_react@18.2.0/node_modules/react-joyride/es/index.js + 8 modules
var es = __webpack_require__(32362);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.13_react@18.2.0/node_modules/@heroicons/react/20/solid/esm/PlusIcon.js
var PlusIcon = __webpack_require__(61097);
// EXTERNAL MODULE: ./node_modules/.pnpm/@metatrustlabs+ui-base@0.2.13_react-dom@18.2.0_react@18.2.0_typescript@4.7.2/node_modules/@metatrustlabs/ui-base/dist/ui-base.esm.js + 61 modules
var ui_base_esm = __webpack_require__(90333);
;// CONCATENATED MODULE: ./src/components/onboarding/OnboardingTooltip.tsx





var OnboardingTooltip = function(param) {
    var continuous = param.continuous, index = param.index, step = param.step, backProps = param.backProps, closeProps = param.closeProps, primaryProps = param.primaryProps, tooltipProps = param.tooltipProps, skipProps = param.skipProps, size = param.size, style = param.style, _showProgress = param.showProgress, showProgress = _showProgress === void 0 ? true : _showProgress, nextButtonText = param.nextButtonText, isLastStep = param.isLastStep, progress = param.progress;
    var progressNode = "".concat(index + 1, "/").concat(size);
    if (progress) {
        if (typeof progress === "function") {
            progressNode = progress(index, size);
        } else {
            progressNode = progress;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        style: style,
        className: "rounded-md bg-gray-50 py-8 px-12 text-gray-800"
    }, tooltipProps), {
        children: [
            !step.hideCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, skipProps), {
                className: "absolute right-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* default */.Z, {
                    className: "h-6 w-6 rotate-45 text-gray-400"
                })
            })),
            step.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-left font-bold",
                children: step.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-6 text-left",
                children: step.content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-end gap-x-4",
                children: [
                    index === 0 && !step.hideSkipButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_base_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        intent: "secondary",
                        className: "min-w-[7rem]"
                    }, skipProps), {
                        children: "No, thanks"
                    })),
                    index > 0 && !step.hideBackButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_base_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: "min-w-[7rem]"
                    }, backProps), {
                        children: "Previous"
                    })),
                    continuous && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_base_esm/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        intent: "highlight",
                        className: "min-w-[7rem]"
                    }, primaryProps), {
                        children: step.nextButtonText || (nextButtonText ? nextButtonText : isLastStep ? "OK" : "Next")
                    }))
                ]
            }),
            showProgress && size > -1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-12 bottom-9 text-sm text-gray-700",
                children: progressNode
            })
        ]
    }));
};
/* harmony default export */ var onboarding_OnboardingTooltip = (OnboardingTooltip);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.4_@babel+core@7.19.6_react-dom@18.2.0_react@18.2.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(68238);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/onboarding/OnboardingTour.tsx









var ReactJoyride = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 32362));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32362)
            ];
        }
    },
    ssr: false
});
var OnboardingTour = function(param) {
    var id = param.id, steps = param.steps, stepIndex = param.stepIndex, styles = param.styles, tooltipComponent = param.tooltipComponent, _forceRun = param.forceRun, forceRun = _forceRun === void 0 ? false : _forceRun, _onFinish = param.onFinish, onFinish = _onFinish === void 0 ? function() {} : _onFinish, helper = param.helper, cta = param.cta, delayRun = param.delayRun, ctaHelper = param.ctaHelper, tooltipStyle = param.tooltipStyle, nextButtonText = param.nextButtonText, showProgress = param.showProgress, progress = param.progress, spotlightClicks = param.spotlightClicks, callback = param.callback;
    var shouldRun = (0,useOnboarding/* useOnboardingState */.G)(id).shouldRun;
    var removeShouldRun = (0,useOnboarding/* useOnboarding */.k)().removeShouldRun;
    var ref = (0,react.useState)(false), runCTA = ref[0], setRunCTA = ref[1];
    var ref1 = (0,react.useState)(forceRun || !delayRun), show = ref1[0], setShow = ref1[1];
    (0,react.useEffect)(function() {
        if (delayRun && !forceRun) {
            setTimeout(function() {
                setShow(true);
            }, delayRun);
        }
    }, [
        delayRun,
        forceRun
    ]);
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactJoyride, {
                continuous: true,
                disableScrolling: true,
                disableOverlayClose: true,
                spotlightClicks: spotlightClicks,
                run: shouldRun || forceRun,
                stepIndex: stepIndex,
                getHelpers: function(data) {
                    if (helper) {
                        helper.current = data;
                    }
                },
                tooltipComponent: tooltipComponent ? tooltipComponent : function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding_OnboardingTooltip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        style: tooltipStyle,
                        showProgress: showProgress,
                        progress: progress,
                        nextButtonText: nextButtonText
                    }));
                },
                styles: styles,
                steps: steps,
                callback: function(data) {
                    var status = data.status, action = data.action, lifecycle = data.lifecycle;
                    if (status === es.STATUS.FINISHED) {
                        removeShouldRun(id);
                        if (cta) {
                            setRunCTA(true);
                        } else {
                            onFinish();
                        }
                    }
                    if (action === es.ACTIONS.SKIP) {
                        removeShouldRun(id);
                        onFinish();
                    }
                    callback && callback(data);
                }
            }),
            cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactJoyride, {
                continuous: true,
                disableOverlayClose: true,
                disableScrolling: true,
                run: runCTA,
                getHelpers: function(helper) {
                    if (ctaHelper) {
                        ctaHelper.current = helper;
                    }
                },
                spotlightClicks: true,
                tooltipComponent: function(param) {
                    var tooltipProps = param.tooltipProps;
                    switch(cta.placement){
                        case "top":
                        case "top-start":
                        case "top-end":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tooltipProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownIcon/* default */.Z, {
                                    className: "h-10 w-10 animate-bounce text-white"
                                })
                            }));
                        case "bottom":
                        case "bottom-start":
                        case "bottom-end":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tooltipProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpIcon/* default */.Z, {
                                    className: "animate-bounce-up h-10 w-10 text-white"
                                })
                            }));
                        case "left":
                        case "left-start":
                        case "left-end":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tooltipProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {
                                    className: "animate-bounce-right h-10 w-10 text-white"
                                })
                            }));
                        case "right":
                        case "right-start":
                        case "right-end":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tooltipProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* default */.Z, {
                                    className: "animate-bounce-left h-10 w-10 text-white"
                                })
                            }));
                    }
                },
                styles: {
                    options: {
                        arrowColor: "transparent"
                    }
                },
                steps: [
                    {
                        target: cta.target,
                        placement: cta.placement,
                        title: "",
                        content: "",
                        disableBeacon: true,
                        hideFooter: true,
                        disableScrolling: true
                    }, 
                ],
                callback: function(param) {
                    var status = param.status;
                    if (status === es.STATUS.FINISHED) {
                        setRunCTA(false);
                        onFinish();
                    }
                }
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var onboarding_OnboardingTour = (OnboardingTour);


/***/ }),

/***/ 22530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useIntegrationTypes; },
/* harmony export */   "N": function() { return /* binding */ useIntegrations; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29452);
/* harmony import */ var _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14498);
/* harmony import */ var _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83094);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16747);




function useIntegrations() {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)([
        _api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.integration.fetchIntegration.url */ .X9.integration.fetchIntegration.url
    ], function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
            var data;
            return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.integration.fetchIntegration */ .X9.integration.fetchIntegration);
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(url) {
            return _ref.apply(this, arguments);
        };
    }(), {
        revalidateOnFocus: true
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        integrationList: data || [],
        isLoading: !error && !data,
        isError: error,
        mutate: mutate
    };
}
function useIntegrationTypes() {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)([
        _api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.integration.fetchIntegrationTypes.url */ .X9.integration.fetchIntegrationTypes.url
    ], function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
            var data;
            return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.integration.fetchIntegrationTypes */ .X9.integration.fetchIntegrationTypes);
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(url) {
            return _ref.apply(this, arguments);
        };
    }(), {
        refreshInterval: 0,
        revalidateOnFocus: false
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        integrationTypes: data,
        isLoading: !error && !data,
        isError: error,
        mutate: mutate
    };
}


/***/ }),

/***/ 2455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useOnboardingState; },
/* harmony export */   "k": function() { return /* binding */ useOnboarding; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49980);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53466);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6135);



var useOnboardingStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set) {
    return {
        lastRun: 0,
        shouldRun: [],
        skipped: false,
        addShouldRun: function(ids) {
            return set(function(state) {
                return {
                    shouldRun: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(state.shouldRun).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ids)).reduce(function(prev, cur) {
                        return prev.includes(cur) ? prev : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat([
                            cur
                        ]);
                    }, [])
                };
            });
        },
        setShouldRun: function(ids) {
            return set(function(state) {
                return {
                    shouldRun: ids
                };
            });
        },
        removeShouldRun: function(id) {
            return set(function(state) {
                var idx = state.shouldRun.findIndex(function(item) {
                    return item === id;
                });
                var newShouldRun = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(state.shouldRun);
                if (idx !== -1) {
                    newShouldRun.splice(idx, 1);
                }
                return {
                    shouldRun: newShouldRun
                };
            });
        },
        setSkipped: function(skipped) {
            return set(function() {
                return {
                    skipped: skipped
                };
            });
        },
        setLastRun: function(timestamp) {
            return set(function() {
                return {
                    lastRun: timestamp
                };
            });
        }
    };
}, {
    name: "onboarding",
    getStorage: function() {
        return localStorage;
    }
}));
var useOnboardingState = function(id) {
    return useOnboardingStore(function(state) {
        return {
            shouldRun: state.shouldRun.includes(id)
        };
    });
};
var useOnboarding = function() {
    return useOnboardingStore(function(state) {
        return {
            lastRun: state.lastRun,
            shouldRun: state.shouldRun,
            skipped: state.skipped,
            setShouldRun: state.setShouldRun,
            removeShouldRun: state.removeShouldRun,
            setLastRun: state.setLastRun,
            setSkipped: state.setSkipped
        };
    });
};


/***/ }),

/***/ 22049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ debounce; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49980);

var debounce = function(fn, wait) {
    var timeout = null; //定义一个定时器
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (timeout !== null) clearTimeout(timeout); //清除这个定时器
        timeout = setTimeout(function() {
            fn.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(args));
        }, wait);
    };
};


/***/ }),

/***/ 49710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bn": function() { return /* binding */ serializeSorter; },
/* harmony export */   "CK": function() { return /* binding */ markdownLinkFromat; },
/* harmony export */   "Eh": function() { return /* binding */ toNowDate; },
/* harmony export */   "G0": function() { return /* binding */ formatDurationBetween; },
/* harmony export */   "Jl": function() { return /* binding */ transformData; },
/* harmony export */   "PV": function() { return /* binding */ formatGithubAddress; },
/* harmony export */   "_v": function() { return /* binding */ formatSourceLine; },
/* harmony export */   "by": function() { return /* binding */ generateHash; },
/* harmony export */   "e$": function() { return /* binding */ DEFAULT_DATE_TIME_FORMAT; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "qv": function() { return /* binding */ formatDurationMillis; },
/* harmony export */   "sS": function() { return /* binding */ formatFileSize; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; }
/* harmony export */ });
/* unused harmony exports parseDate, string2number */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45680);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(655);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37705);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43857);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_3__);




dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2___default()));
var DEFAULT_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
function formatDate(date) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_DATE_TIME_FORMAT;
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format(format);
}
var toNowDate = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().to(formatDate(date));
};
var parseDate = function(date) {
    return dayjs(date).toDate();
};
var serializeSorter = function(param) {
    var sorter = param.sorter;
    return "".concat(sorter.property, ",").concat(sorter.ascending ? "asc" : "desc");
};
var string2number = function(str) {
    var value = parseInt(str);
    if (isNaN(value)) return undefined;
    return value;
};
var formatNumber = function(num) {
    if (num < 1000) {
        return num.toFixed(0);
    } else {
        return (num / 1000).toFixed(1) + "K";
    }
};
var formatDurationMillis = function(duration) {
    var dur = Math.max(1000, duration); // 不足1s显示1s
    var beforeFormatDuration = dayjs__WEBPACK_IMPORTED_MODULE_0___default().duration(dur, "milliseconds");
    var formatString = "";
    if (beforeFormatDuration.asDays() >= 1) {
        formatString = "D[d] H[h]";
    } else if (beforeFormatDuration.asHours() >= 1) {
        formatString = "H[h] m[m]";
    } else if (beforeFormatDuration.asMinutes() >= 1) {
        formatString = "m[m] s[s]";
    } else {
        formatString = "s[s]";
    }
    return beforeFormatDuration.format(formatString).replace(/\b0[dhms]\b/g, "");
};
var formatDurationBetween = function(startTime, endTime) {
    var diffMillis = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(endTime).diff(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(startTime), "milliseconds");
    return formatDurationMillis(diffMillis);
};
var markdownLinkFromat = function(mdStr, baseUrl, sub_path) {
    var linkReg = /\[(.*?)\]\((.*?)\)/gi; // (?<!!) 不做图片格式的字符串过滤
    if (!sub_path) return mdStr.replace(linkReg, "[$1](".concat(baseUrl, "/$2)"));
    return mdStr.replace(linkReg, "[$1](".concat(baseUrl, "/").concat(sub_path, "/$2)"));
};
function formatFileSize(size) {
    if (size < 1024) {
        return size + " bytes";
    } else if (size >= 1024 && size < 1048576) {
        return (size / 1024).toFixed(1) + " KB";
    } else if (size >= 1048576) {
        return (size / 1048576).toFixed(1) + " MB";
    }
}
var formatSourceLine = function(isGithub, baseHref, line_start, line_end) {
    return isGithub ? "".concat(baseHref, "#L").concat(line_start, "-#L").concat(line_end) : "".concat(baseHref, "#L").concat(line_start, "-").concat(line_end);
};
var formatGithubAddress = function(param) {
    var _baseUrl = param.baseUrl, baseUrl = _baseUrl === void 0 ? "" : _baseUrl, scanParams = param.scanParams;
    var ref;
    return "".concat(baseUrl, "/blob/").concat((scanParams === null || scanParams === void 0 ? void 0 : (ref = scanParams.repo) === null || ref === void 0 ? void 0 : ref.commit_hash) || (scanParams === null || scanParams === void 0 ? void 0 : scanParams.repo.branch) || "");
};
function generateHash(str) {
    var hash = crypto__WEBPACK_IMPORTED_MODULE_3___default().createHash("sha256");
    hash.update(str);
    return hash.digest("hex");
}
function transformData(data) {
    var result = {
        type: "directory",
        name: ".",
        contents: []
    };
    var directoriesCount = 0;
    data.forEach(function(entry) {
        var _loop = function(i) {
            var part = parts[i];
            if (i === parts.length - 1) {
                if (entry.directory) {
                    directoriesCount++;
                    currentDirectory.contents.push({
                        type: "directory",
                        name: part,
                        contents: []
                    });
                } else {
                    currentDirectory.contents.push({
                        type: "file",
                        name: part
                    });
                }
            } else {
                var subDirectory = currentDirectory.contents.find(function(dir) {
                    return dir.type === "directory" && dir.name === part;
                });
                if (!subDirectory) {
                    directoriesCount++;
                    subDirectory = {
                        type: "directory",
                        name: part,
                        contents: []
                    };
                    currentDirectory.contents.push(subDirectory);
                }
                currentDirectory = subDirectory;
            }
        };
        var parts = entry.filename.split("/").filter(function(item) {
            return item !== ".";
        });
        var currentDirectory = result;
        for(var i = 0; i < parts.length; i++)_loop(i);
    });
    return result;
}


/***/ })

}]);